(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('giftgo-whatsapp-order')) {
    customElements.define(
      'giftgo-whatsapp-order',
      class GiftGoWhatsAppOrder extends HTMLElement {
        connectedCallback() {
          this.link = this.querySelector('[data-giftgo-wa-link]');
          this.nameInput = this.querySelector('[data-giftgo-wa-name]');
          this.optionNames = this.parseJson(this.dataset.optionNames, []);
          this.variant = this.parseJson(this.dataset.initialVariant, null);
          this.handleNameInput = this.handleNameInput.bind(this);
          this.handleLinkClick = this.handleLinkClick.bind(this);
          this.handleVariantChange = this.handleVariantChange.bind(this);
          this.nameInput?.addEventListener('input', this.handleNameInput);
          this.link?.addEventListener('click', this.handleLinkClick);
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange);
          }
          this.updateLink();
        }

        disconnectedCallback() {
          this.nameInput?.removeEventListener('input', this.handleNameInput);
          this.link?.removeEventListener('click', this.handleLinkClick);
          this.unsubscribe?.();
        }

        parseJson(value, fallback) {
          try {
            return JSON.parse(value);
          } catch (error) {
            return fallback;
          }
        }

        handleNameInput() {
          this.nameInput.setCustomValidity('');
          this.updateLink();
        }

        handleLinkClick(event) {
          if (!this.nameInput.value.trim()) {
            event.preventDefault();
            this.nameInput.setCustomValidity(this.dataset.nameRequired);
            this.nameInput.reportValidity();
            this.nameInput.focus();
            return;
          }
          this.updateLink();
        }

        handleVariantChange({ data }) {
          if (String(data.sectionId) !== this.dataset.sectionId) return;
          this.variant = data.variant;
          this.updateLink();
        }

        formatPrice(cents) {
          const value = Number(cents) / 100;
          try {
            return new Intl.NumberFormat(document.documentElement.lang || 'en-NG', {
              style: 'currency',
              currency: this.dataset.currency || 'NGN',
              maximumFractionDigits: 0,
            }).format(value);
          } catch (error) {
            return `₦${value.toLocaleString()}`;
          }
        }

        buildMessage() {
          if (!this.variant) return '';
          const name = this.nameInput.value.trim() || this.dataset.namePlaceholder;
          const productTitle = this.dataset.productTitle;
          const intro = this.dataset.messageIntro
            .replace('[[name]]', name)
            .replace('[[product]]', productTitle);
          const lines = [
            this.dataset.messageGreeting,
            '',
            intro,
            '',
            `${this.dataset.productLabel}: ${productTitle}`,
          ];
          const values = Array.isArray(this.variant.options) ? this.variant.options : [];
          values.forEach((value, index) => {
            if (!value || value === 'Default Title') return;
            const optionName = this.optionNames[index] || `Option ${index + 1}`;
            const unit = optionName.toLowerCase().includes('size') ? ` ${this.dataset.sizeUnit}` : '';
            lines.push(`${optionName}: ${value}${unit}`);
          });
          lines.push(`${this.dataset.priceLabel}: ${this.formatPrice(this.variant.price)}`);
          lines.push('', this.dataset.closing, '');
          lines.push(`${this.dataset.linkLabel}: ${this.dataset.productUrl}?variant=${this.variant.id}`);
          return lines.join('\n');
        }

        updateLink() {
          if (!this.link || !this.variant) return;
          const message = this.buildMessage();
          this.link.href = `https://wa.me/${this.dataset.phone}?text=${encodeURIComponent(message)}`;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
